import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { AuthModule } from './authentication/auth.module';
import { httpInterceptorProviders } from './authentication/interceptors/http-interceptor';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NavigationModule } from './navigation/navigation.module';
import { CoreModule } from './common/core.module';
import { AppRoutingModule } from './app.routes';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { AccountConfigurationModule } from './account-configuration/account-configuration.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NavigationModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    AuthModule,
    AccountConfigurationModule,
    MatDialogModule,
    MatLegacyDialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      },
      extend: true
    })
  ],
  providers: [
    CookieService,
    { provide: OAuthStorage, useValue: localStorage },
    httpInterceptorProviders
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
